import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { finalize, map, tap } from "rxjs/operators";
import { iReservation } from "@ui-components/models";

@Injectable({
    providedIn: 'root'
})
export class ReservationsService {

    private reservationsSubject = new BehaviorSubject<iReservation[]>([]);
    reservations$: Observable<iReservation[]> = this.reservationsSubject.asObservable()
    .pipe(
        map(r => r && r.sort(sortByDate))
    );

    private loaderSubject = new BehaviorSubject<boolean>(false);
    showLoader$: Observable<boolean> = this.loaderSubject.asObservable();

    constructor(private http: HttpClient) { }

    getReservations(query: { reservationDate: Date, locationId: number }): Observable<iReservation[]> {

        const stringDate = {
            year: query.reservationDate.getFullYear(),
            month: query.reservationDate.getMonth() + 1,
            date: query.reservationDate.getDate()
        }

        this.loaderSubject.next(true);

        let requestPath = `/EventsOccurance/GetEventOccuranceByDate/${stringDate.year}-${stringDate.month}-${stringDate.date}/`;
        if (query.locationId != 0) { requestPath += query.locationId }

        return this.http.get<iReservation[]>(requestPath)
            .pipe(
                map(r => r && r.sort(sortByDate)),
                tap((reservations) => this.reservationsSubject.next(reservations)),
                finalize(() => this.loaderSubject.next(false))
            )
    }

    reserve(payload) {
        payload.reservationDate.setSeconds(0,0);
        payload.fromTime.setSeconds(0,0); 
        payload.toTime.setSeconds(0,0);

        this.loaderSubject.next(true);
        return this.http.post('/EventsOccurance/AddEventOccurrence', payload);
    }

    deleteReservation(id) {
        this.loaderSubject.next(true);
        return this.http.delete(`/EventsOccurance/DeleteReservation/${id}`)
        .pipe(
            finalize(() => {
                this.loaderSubject.next(false);
            })
        )
    }

}

export function sortByDate(a1: iReservation, a2: iReservation){
    return a1.fromTime.getTime() - a2.fromTime.getTime()
}
